import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { RouterModule, Routes } from '@angular/router';
import { Routing } from './pages/routing';
import { HeaderComponent } from './components/header/header.component';
import { ContentComponent } from './components/content/content.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarDrawerComponent } from './components/sidebar-drawer/sidebar-drawer.component';
import { HeaderMenuComponent } from './components/header/header-menu/header-menu.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarLogoComponent } from './components/sidebar/sidebar-logo/sidebar-logo.component';
import { SidebarMenuComponent } from './components/sidebar/sidebar-menu/sidebar-menu.component';
import { SidebarFooterComponent } from './components/sidebar/sidebar-footer/sidebar-footer.component';
import { NavbarComponent } from './components/header/navbar/navbar.component';
import { HttpClientModule } from '@angular/common/http';
import { InlineSVGModule } from 'ng-inline-svg';
import { UserMenuComponent } from './components/header/navbar/user-menu/user-menu.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { RangeTypeComponent } from './components/range-type/range-type.component';
import { CouponPerformanceComponent } from './pages/coupon-performance/coupon-performance.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { RadioGroupRangeTypeComponent } from './components/radio-group-range-type/radio-group-range-type.component';
import { SelectDateRangeTypeComponent } from './components/select-date-range-type/select-date-range-type.component';
import { MaterialModule } from './material/material.module';
import { ChartComponentComponent } from './components/chart-component/chart-component.component';
import { NgChartsModule } from 'ng2-charts';
import { TableComponent } from './components/table-component/table-component.component';
import { SearchComponent } from './components/search-component/search-component.component';
import { UpsellRatesComponent } from './pages/upsell-rates/upsell-rates.component';
import { PetDemographicsComponent } from './pages/pet-demographics/pet-demographics.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: Routing,
  },
];

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    ContentComponent,
    FooterComponent,
    SidebarDrawerComponent,
    HeaderMenuComponent,
    SidebarComponent,
    SidebarLogoComponent,
    SidebarMenuComponent,
    SidebarFooterComponent,
    NavbarComponent,
    UserMenuComponent,
    RangeTypeComponent,
    CouponPerformanceComponent,
    RadioGroupRangeTypeComponent,
    SelectDateRangeTypeComponent,
    ChartComponentComponent,
    TableComponent,
    SearchComponent,
    UpsellRatesComponent,
    PetDemographicsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    HttpClientModule,
    NgbDropdownModule,
    InlineSVGModule.forRoot(),
    ReactiveFormsModule,
    MatNativeDateModule,
    MaterialModule,
    NgChartsModule,
  ],
  providers: [DatePipe],
})
export class LayoutModule {}
